// SSO rule (non-negotiable): the login redirect navigates the browser
// top-level to the API host so the provider's `openid.<provider>` state
// cookie is set on that host. Routing the same value through the same-origin
// `/api` proxy path would land the cookie on the portal host instead, and the
// callback would see no cookie -> INVALID_CREDENTIALS. `PUBLIC_API_URL` must
// therefore always be an absolute `http(s)://host` value, never a path.
export function absoluteUrl(value) {
    const unexpanded = unexpandedPlaceholder(value);
    if (unexpanded)
        return unexpanded;
    let parsed;
    try {
        parsed = new URL(value);
    }
    catch {
        return `must be an absolute URL (e.g. "https://api.example.com"), got "${value}"`;
    }
    if (parsed.protocol !== "https:" && parsed.protocol !== "http:") {
        return `must be an http(s) URL, got "${value}"`;
    }
    return undefined;
}
// A `$VAR` / `${VAR}` left in a value means a template was shipped instead of
// its substitution — the per-environment .env files carry placeholders like
// `$PR_NUMBER` that the deploying chart is expected to override. Such a value
// still parses as a URL, so without this check it reaches the browser intact
// and only shows up as a request to a host that cannot resolve.
export function unexpandedPlaceholder(value) {
    const match = /\$\{?[A-Za-z_][A-Za-z0-9_]*\}?/.exec(value);
    if (!match)
        return undefined;
    return `still contains the unexpanded placeholder "${match[0]}" — the deploying chart must set this value, got "${value}"`;
}
//# sourceMappingURL=validators.js.map